import { IonIcon, IonList, IonItem, IonLabel, IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react';
import { documentTextOutline, folderOutline } from 'ionicons/icons';
import { Link, useParams } from 'react-router-dom';

const FolderList: React.FC = ({ folders, repo_id }) => {
    const title = "Folders"
    const subtitle = "Subtitle"
    const docs = folders

    return (<>
    {docs.length > 0 ? (
        <IonList className="py-2">
            {docs.map((doc, index) => (
                <Link to={`/folders/${doc.id}/${doc.name}`} key={index} >
                <IonItem
                    button={true}
                    lines="none"
                    className="transition-colors duration-200"
                >
                    <IonIcon icon={folderOutline} slot="start" className="text-blue-500 dark:text-blue-400" />
                    <IonLabel className="text-gray-700 dark:text-gray-300">
                        <h3 className="font-medium truncate">{doc.name}</h3>
                    </IonLabel>
                </IonItem>
                </Link>
            ))}
        </IonList>
    ) : (
        <div className="p-8 text-center">
            <IonIcon icon={folderOutline} className="text-4xl text-gray-400 dark:text-gray-500 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">No documents uploaded yet</p>
        </div>
    )}
    </>);
};

export default FolderList;
